// Camera wit sticker

import { useState } from 'react';
import Webcam from "react-webcam";
import { translate } from '../functions/translationHelper';

function ContentCamera(props) {

  //const [zoom, setZoom] = useState(1);
  const [error, setError] = useState(false);



  return (
    <div className="page-content-camera">
      {error &&
        <div className='cameraerrormessage'>
          {translate("camera_permission_denied", props.language)}
        </div>
      }
      {/*
      <input
        type='range'
        min={0.2}
        max={1}
        className='camerastickerslider'
        value={zoom}
        onChange={(e) => setZoom(e.target.value)}
  />*/}
      <img src={props.baseurl + props.content?.sticker} className='camerasticker' />

      {props.active &&
        <Webcam
          audio={false}
          videoConstraints={{ facingMode: "environment" }}
          style={{width: '100%', height: '100%', objectFit: 'cover', position: 'center'}}
          onUserMedia={() => setError(false)}
          onUserMediaError={() => setError(true)}
        />
      }
    </div>
  );
}

export default ContentCamera;
